import { SVGAttributes } from 'react';

export default function (props: SVGAttributes<SVGElement>) {
    return (
        <svg width={29} height={29} viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M10.5 14l4-8 4 8h-8z" />
            <path id="south" d="M10.5 16l4 8 4-8h-8z" fill="#ccc" />
        </svg>
    );
}
